import {
    SET_EXERCISE,
    SET_PLAYING_VIDEO_E,
    SET_PENDING_EXERCISE,
    SET_TRENDING_EXERCISE,
    SET_NEXT_EXERCISES,
    SET_TOP_FAVORITE_EXERCISE,
    SET_TOP_WATCHED_EXERCISE,
    SET_TOP_FINISHED_EXERCISE,
    SET_EXERCISE_TYPES,
    SET_FILTERED_EXERCISES,
} from "./types";

const initialState = {
    exercise: null,
    exercises: [],
    playing: {},
    pendingExercise: null,
    trendingExercises: [],
    nextExercises: [],

    favoriteExercisesTop: null,
    watchedExercisesTop: null,
    finishedExercisesTop: null,
    filteredExercises: null,
    exerciseTypes: [],
    exerciseRegions: [],

};

export default function (state = initialState, action) {

    switch (action.type) {
        case SET_EXERCISE:
            return {
                ...state,
                exercise: action.data
            }

        case SET_PLAYING_VIDEO_E:
            return {
                ...state,
                playing: action.data
            }

        case SET_PENDING_EXERCISE:
            return {
                ...state,
                pendingExercise: action.data
            }

        case SET_NEXT_EXERCISES:
            return {
                ...state,
                nextExercises: action.data
            }

        case SET_TRENDING_EXERCISE:
            return {
                ...state,
                trendingExercises: [...action.data]
            }

        case SET_TOP_FAVORITE_EXERCISE:
            return {
                ...state,
                favoriteExercisesTop: action.data
            }

        case SET_TOP_WATCHED_EXERCISE:
            return {
                ...state,
                watchedExercisesTop: action.data
            }

        case SET_TOP_FINISHED_EXERCISE:
            return {
                ...state,
                finishedExercisesTop: action.data
            }

        case SET_EXERCISE_TYPES:
            return {
                ...state,
                exerciseTypes: action.data,
                exerciseRegions: action.data2
            }


        case SET_FILTERED_EXERCISES:
            return {
                ...state,
                filteredExercises: action.data
            }

        default:
            return state;
    }
}